import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { SelectablesService } from '../selectables.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { LRFormService } from '../l-r-form.service';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';

import swal from 'sweetalert2';
import { environment } from '../../environments/environment';

import { ConsignorService } from '../_services/_masters/consignor.service';
import { ProductService } from '../_services/_masters/product.service';
import { OnAccountService } from '../_services/_masters/on-account.service';
import { PartyService } from '../_services/_masters/party.service';
import { VehicleService } from '../_services/_masters/vehicle.service';
import { DestinationService } from '../_services/_masters/destination.service';
import { RRFormService } from '../r-r-form.service';
import { DatePipe } from '@angular/common';

// import * as $ from 'jquery';
declare var $ : any;



const user_info = JSON.parse(localStorage.getItem('currentUser'));
const headers = new Headers({'Content-Type': 'application/json','Authorization': JSON.parse(localStorage.getItem("user_token"))});
const options = new RequestOptions({ headers: headers });


class LRForm {
	lr_date: string;
	lr_number: string;
	consignor: string;
	loading: string;
	station: string;
	on_account : string;
	party:string;
	truck_number: string;
	owned_by: string;
	sto_number : string;
	freight_rate : string;
	freight_amt : string;
	advance_paid : string;
	balance : string;
	diesel_amt : string;
	product: string;
	weight:string;
	qty_bags:string;
	rr_date : string;
	rr_number: string;
}

@Component({
  selector: 'app-l-r-acknowledge',
  templateUrl: './l-r-acknowledge.component.html',
  styleUrls: ['./l-r-acknowledge.component.css']
})
export class LRAcknowledgeComponent implements OnInit {

	lRForm : FormGroup;
	check_branch: boolean = true;
	selected_branch_name="";

	stations : string[] = [];
	products : string[] = [];
	consignors: any[] = [];
	onaccount: string[] = [];
	party: string[] = [];
	godowns: any[] = [];
	truckno:string[]=[];
	destination:string[]=[];
	product_package=[];
	rr_number:any[]=[];
	get_product_package:any;

	advance_info_flag : boolean = false;
	lr_saved : boolean = false;

	bsConfig: Partial<BsDatepickerConfig>;

	// dtOptions: DataTables.Settings = {};
	dtOptions: any = {};
	lrform: LRForm[] = [];
	modalLRForm :FormGroup;
	modalData:any;
	// We use this trigger because fetching the list of persons can be quite long,
	// thus we ensure the data is fetched before rendering
	dtTrigger: Subject<any> = new Subject();
	message:any;
	selected_rr_num:any;
	loadPoint:any;
	selected_branch:string;
	selected_client:string;
	selected_advance_info:any;
	selected_godown_to :boolean = false;
	lr_no :number = null;

	url = environment.url;
	lr_date:Date=new Date(Date.now());
	query : any =null;
	ack_date:any;
	
	constructor(
		private lRFormService : LRFormService, 
		private http: Http, 
		private selectablesService : SelectablesService ,
		private selectConsignerService : ConsignorService,
		private selectProductService : ProductService,
		private selectBranchService : SelectablesService,
		private onAccountService : OnAccountService,
		private partyService : PartyService,
		private VehicleService:VehicleService,
		public RRFormService:RRFormService,
		private DestinationService:DestinationService,
		private datePipe:DatePipe
	) { }	

	response :any;

  ngOnInit() {
  		this.selected_rr_num = this.selectablesService.selected_rr_number;
		this.loadPoint = this.getSelectedLoadingPoint()
		this.selected_branch = this.selectablesService.selected_branch;
		this.selected_client = this.selectablesService.selected_client;
		this.selected_advance_info = this.selectablesService.advance_info;

		this.lRForm = new FormGroup({
			'rr_number': new FormControl(this.selected_rr_num),
			'lr_number': new FormControl(null),
			'sto_number' : new FormControl(null),
			'lr_date': new FormControl(null, Validators.required),
			'station': new FormControl(this.selected_branch, Validators.required),
			'consignor' : new FormControl(this.selected_client, Validators.required),
			'loading' : new FormControl(this.loadPoint, Validators.required),
			'on_account': new FormControl(null, Validators.required),
			'party' : new FormControl(null, Validators.required),
			'destination' : new FormControl(null, Validators.required),
			'truck_number':new FormControl(null, Validators.required),
			'owned_by': new FormControl(null, Validators.required),
			'rr_date' : new FormControl(null, Validators.required),
			'freight_rate' : new FormControl(null),
			'freight_amt' : new FormControl(null),
			'advance_paid' : new FormControl(null),
			'balance' : new FormControl(null),
			'diesel_amt' : new FormControl(null),
			'product' : new FormControl(null, Validators.required),
			'weight': new FormControl(null, Validators.required),
			'qty_bags': new FormControl(null, Validators.required),
			'godown': new FormControl(null)
		});


 		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getRRNumber();
				this.getBranch();
				this.getConsignorBySelectedBranch(null);
				//this.getDestinationBySelectedBranch(null);
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				this.lRForm.get('station').setValue(temp['branch']);
  				this.stations.push(temp['branch']);
				this.getConsignorBySelectedBranch(temp['branch']);
				this.getRRFormWithBranch(temp['branch']);
				//this.getDestinationBySelectedBranch(temp['branch']);
				this.check_branch = true;
			}
		}

		this.getOnAccount();
		this.getParty();
		this.getTruckNo();
		// this.changeLoading(this.lRForm.get('loading').value);
		this.getGodownBySelectedClient(this.lRForm.get('consignor').value);
	}
	getRRNumber()
    {
    	this.rr_number=[];
    	this.RRFormService.getAllRRForm()
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
    }
    getRRFormWithBranch(branch)
    {
    	this.rr_number=[];
    	this.RRFormService.getRRFormWithBranch(branch)
		.subscribe(
			rr_number => {
				for(var i=0;i<rr_number.length;i++)
				{
					this.rr_number.push(rr_number[i]['rr_number']);
				}
			});
    }
	getDestination()
    {
    	this.destination=[];
		this.DestinationService.getAllDestination()
		.subscribe(
			destination => {
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{
					this.destination.push(destination[i]['destination_name']);
				}
			});
    }
    getDestinationBySelectedBranch(branch)
    {
    	this.destination=[];
    	this.DestinationService.getDestinationFormWithBranch(branch)
		.subscribe(
			destination => {
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{
					this.destination.push(destination[i]['destination_name']);
				}
			});
    }
    getConsignerAndDestination(branch)
    {
    	this.getConsignorBySelectedBranch(branch);
		this.getDestinationBySelectedBranch(branch);
    }
	getTruckNo()
    {
     	this.VehicleService.getAllVehicle()
		.subscribe(
			truckno => {
				for(var i=0;i<truckno.length;i++)
				{
					this.truckno.push(truckno[i]['truck_no']);
				}
			});
    }
	getOnAccount()
    {
     	this.onAccountService.getAllOnAccount()
		.subscribe(
			onaccount => {
				for(var i=0;i<onaccount.length;i++)
				{
					this.onaccount.push(onaccount[i]['account_name']);
				}
			});
    }
    getParty()
    {
     	this.partyService.getAllParty()
		.subscribe(
			party => {
				for(var i=0;i<party.length;i++)
				{
					this.party.push(party[i]['party_name']);
				}
			});
    }
	getConsignor()
    {
     	this.selectConsignerService.getAllConsignor()
		.subscribe(
			consignors => {
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
    }
    getDestinationBySelectedBranchAndClient(client)
    {
    	let destination_table_name=this.selected_branch_name+"_"+client+"_destination";
    	this.destination=[];
    	this.DestinationService.getDestinationFormWithClientAndBranch(destination_table_name)
		.subscribe(
			destination => {;
				console.log(destination);
				for(var i=0;i<destination.length;i++)
				{
					this.destination.push(destination[i]['destination_name']);
				}
			});
    }
    getProductAndDestinationByBranchAndClient(client)
    {	
    	this.getConsignerAndDestination(this.lRForm.get("station").value);
    	this.getProductBySelectedClient(client);
		this.getDestinationBySelectedBranchAndClient(client);
		this.getGodownBySelectedClient(client);
    }
    getConsignorBySelectedBranch(branch)
    {
    	this.selected_branch_name=branch;
    	this.consignors=[];
     	this.selectConsignerService.getConsignorFormWithBranch(branch)
		.subscribe(
			consignors => {
				//alert(consignors);
				
				for(var i=0;i<consignors.length;i++)
				{
					this.consignors.push(consignors[i]['consignor_name']);
				}
			});
    }
    getProductBySelectedClient($event)
    {
    	this.products=[];
    	this.selectProductService.getProductByClientName($event)
		.subscribe(
			products => {
				for(var i=0;i<products.length;i++)
				{
					this.products.push(products[i]['product_name']);
					this.product_package.push(products[i]);
				}
			});
    }
    getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
    }

    getProductQty(product_weight)
    {
    	let get_product_qty = product_weight.target.value*1000/this.get_product_package;
    	if (!isNaN(get_product_qty))
    		this.lRForm.get('qty_bags').setValue(get_product_qty);
    	else
    		this.lRForm.get('qty_bags').setValue("");
    }
    getProductWeight(product_qty)
    {
    	let get_product_weight = product_qty.target.value*this.get_product_package/1000;
    	if (!isNaN(get_product_weight))
    		this.lRForm.get('weight').setValue(get_product_weight);
    	else
    		this.lRForm.get('weight').setValue("");
    }
    getProductPacking(product_name)
    {
    	if(product_name)
    	{
    		this.get_product_package = this.product_package.find( x => x.product_name == product_name).packing;
    	}
    }
    
  	getSelectedLoadingPoint(){
		var point = this.selectablesService.selected_loading_point;
		console.log("getSeletecLoading-LR: " + point);
		if (point == 'rail' || point == 'By Rail'){
			return "By Rail";
		}
		else if(point == 'godown' || point == 'By Godown') {
			return "By Godown";
		}

		else{
			return "By Rail"
		}
	};

	setBalance(get_pait_amount)
	{
		let total_amount = parseFloat(this.lRForm.get('freight_amt').value );
		let advance_amt = (this.lRForm.get('advance_paid').value != null ? this.lRForm.get('advance_paid').value : 0);
		let diesel_amt = (this.lRForm.get('diesel_amt').value != null ? this.lRForm.get('diesel_amt').value : 0);
		let balance = total_amount - (parseFloat(diesel_amt) + parseFloat(advance_amt));
		this.lRForm.get('balance').setValue(balance.toFixed(2));
	}

	deductDieselAmount(diesel_amt){	
		let total_amount = this.lRForm.get('freight_amt').value;
		let advance_amt = (this.lRForm.get('advance_paid').value != null ? this.lRForm.get('advance_paid').value : 0);
		let balance = total_amount - (parseFloat(diesel_amt.target.value ) + parseFloat(advance_amt));
		this.lRForm.get('balance').setValue(balance.toFixed(2));
	};

	calculateFreightAmt(){
		var freight_amt = 0;
		freight_amt = (this.lRForm.get('freight_rate').value * this.lRForm.get('weight').value)
		this.lRForm.patchValue({
			"freight_amt" : freight_amt
		});
	};

	lRFormWith(info: string): void {
		this.lRFormService.getLRFormWith(info)
		.subscribe(response => {
			// console.log(response);
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			console.log(this.modalData[0]);
			this.lRForm.patchValue({

				'consignor': this.modalData[0].consignor,
				'loading': this.modalData[0].loading,
				'station': this.modalData[0].station,
				'on_account': this.modalData[0].on_account,
				'party' : this.modalData[0].party,
				'destination' : this.modalData[0].destination,
				'truck_number': this.modalData[0].truck_number,
				'owned_by': this.modalData[0].owned_by,
				'freight_rate' : this.modalData[0].freight_rate,
				'freight_amt' : this.modalData[0].freight_amt,
				'advance_paid' : this.modalData[0].advance_paid,
				'balance' : this.modalData[0].balance,
				'diesel_amt' : this.modalData[0].diesel_amt,
				'sto_number': this.modalData[0].sto,
				'lr_number': this.modalData[0].lr_number,
				'rr_number': this.modalData[0].rr_number,
				'weight': this.modalData[0].weight,
				'product': this.modalData[0].product,
				"lr_date": this.modalData[0].lr_date,
				"godown": this.modalData[0].godown

			});
		});

		this.getProductAndDestinationByBranchAndClient(this.lRForm.get("consignor").value);
		// this.getGodownBySelectedClient(this.lRForm.get("consignor").value);	
	};

	acknowledgeLR(lr_number:string){
		console.log(lr_number);
		console.log(this.lRForm.value);
		this.http.post( this.url + "/lrform/ack", this.lRForm.value, options)
		//this.http.get( this.url + "/lrform/ack/"+ lr_number)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response);
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'LR Acknowledged'){
					swal(
						' Success',
						'LR Form Acknowledeged Successfully',
						'success'
					);
				}

				if (this.response.message === 'LR Already Acknowledged'){
					this.ack_date = new Date(this.response.acknowledged_date_time);
					this.ack_date = this.datePipe.transform(this.ack_date, 'medium');
					swal(
						' Info ',
						'LR form Already Acknowledeged'+'<br>'+'<b> Acknowledeged on : </b>'+this.ack_date+'<br>'+ '<b> Acknowledeged By : </b>'+this.response.acknowledged_by,
						'info'
					);
				}
			}
			else{
				swal(
					' Acknowledge Failed',
					'Please enter a LR number',
					'error'
				);
			}
			
		});
	};

	getLRFreightRate(){
		console.log("Value Changes for destiantion");
		if (this.lRForm.get('owned_by').value == "By Self"){
			this.query = {
				"branch" : this.lRForm.get("station").value,
				"consignor" : this.lRForm.get("consignor").value,
				"destination_name" : this.lRForm.get("destination").value
			}
			console.log(this.query);
			this.http.post( this.url + "/lr/freight/for", this.query, options)
			.subscribe(res=>{
				console.log(res.json());
				this.response = res.json();
				if(this.response["rate_for_destination"] != 0 ){
					this.lRForm.patchValue({
						"freight_rate" : this.response.rate_for_destination,
						"freight_amt" : (this.response.rate_for_destination * this.lRForm.get('weight').value)
					});
				}
				else if(this.response["rate_for_destination"] == 0){
					swal(
						'No Freight Rate Found!',
						'Please update the Freight Rate sheet or Enter rate manually.',
						'warning'
					);
					this.lRForm.patchValue({
						"freight_rate" : 0,
						"freight_amt" : 0
					});
				}
				
			})
		}
		else{
			this.lRForm.patchValue({
				"freight_amt" : (this.lRForm.get('freight_rate').value * this.lRForm.get('weight').value)
			})
		}
	};

	// Set validator as per selecting loading
	// changeLoading(loadBy)
	// {	
	// 	console.log(loadBy);
	// 	var form_info = localStorage.getItem('form_info');
	// 	var form_data = JSON.parse(form_info);	
	// 	if (loadBy === 'By Rail')
	// 	{	
	// 		this.lRForm.get('rr_number').setValidators([Validators.required]);            
	// 		this.lRForm.get('rr_number').setValue(form_data.rr_number);
	// 		this.lRForm.get('sto_number').setValue(null);
	// 		this.lRForm.get('sto_number').setValidators(null);
	// 		this.lRForm.get('godown').setValue(null);
	// 		this.lRForm.get('godown').setValidators(null);
	// 		this.lRForm.get('rr_number').updateValueAndValidity();
	// 		this.lRForm.get('sto_number').updateValueAndValidity();
	// 		this.lRForm.get('godown').updateValueAndValidity();
	// 		this.getGodownBySelectedClient(this.lRForm.get('consignor').value);
	// 	} 
	// 	else if(loadBy === 'By Godown')  
	// 	{
	// 		this.lRForm.get('sto_number').setValidators([Validators.required]);            
	// 		this.lRForm.get('godown').setValidators([Validators.required]);            
	// 		this.lRForm.get('rr_number').setValue(null);
	// 		this.lRForm.get('godown').setValue(form_data.godown);
	// 		this.lRForm.get('rr_number').setValidators(null);
	// 		this.lRForm.get('sto_number').updateValueAndValidity();
	// 		this.lRForm.get('godown').updateValueAndValidity();
	// 		this.lRForm.get('rr_number').updateValueAndValidity();
	// 		this.getGodownBySelectedClient(this.lRForm.get('consignor').value);
	// 	}
	// };

	getGodownBySelectedClient(client)
	{
		this.godowns=[];
		this.http.get(this.url + "/masters/godown/get/branchandclient/" +this.lRForm.get("station").value + "/" + client, options)
		.subscribe(
			godowns => {
				console.log(godowns);
				var godown = godowns.json()
				console.log(godown);
				for(var i=0;i<godown.length;i++)
				{
					this.godowns.push(godown[i]['godown_name']);
				}
			});
	}

}



// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/l-r-acknowledge/l-r-acknowledge.component.ts